import { BiomeId } from './SaveSystem';

/** Декоративный объект на 4-м плане (без коллизий). */
export interface DecorationData {
  x: number;
  y: number;
  key: string;
  scale: number;
  layer: number;
}

/** Платформа — обычный jumpable элемент с физическим телом h=32. */
export interface PlatformData {
  cx: number;
  cy: number;
  w: number;
  h: number;
}

/** Сплошной блок (стена/пол/потолок) — TileSprite с texture key. */
export interface BlockData {
  cx: number;
  cy: number;
  w: number;
  h: number;
  texture: string; // 'biome1-wall' | 'biome2-wall' и т.п.
}

export interface LevelData {
  biomeId: BiomeId;
  version: number;
  decorations: DecorationData[];
  platforms: PlatformData[];
  blocks: BlockData[];
}

const KEY_PREFIX = 'follow-knight-level-';
const VERSION = 2;

export const LevelStorage = {
  save(data: LevelData): void {
    try {
      localStorage.setItem(KEY_PREFIX + data.biomeId, JSON.stringify(data));
    } catch {
      // ignore
    }
  },

  load(biomeId: BiomeId): LevelData | null {
    try {
      const raw = localStorage.getItem(KEY_PREFIX + biomeId);
      if (!raw) return null;
      const parsed = JSON.parse(raw);
      if (
        parsed?.biomeId === biomeId &&
        typeof parsed?.version === 'number' &&
        Array.isArray(parsed?.decorations)
      ) {
        // Бэкфилл для старых сейвов (v1) без platforms/blocks
        return {
          biomeId: parsed.biomeId,
          version: parsed.version,
          decorations: parsed.decorations,
          platforms: Array.isArray(parsed.platforms) ? parsed.platforms : [],
          blocks: Array.isArray(parsed.blocks) ? parsed.blocks : [],
        };
      }
      return null;
    } catch {
      return null;
    }
  },

  clear(biomeId: BiomeId): void {
    try {
      localStorage.removeItem(KEY_PREFIX + biomeId);
    } catch {
      // ignore
    }
  },

  toJson(data: LevelData): string {
    return JSON.stringify(data, null, 2);
  },

  newEmpty(biomeId: BiomeId): LevelData {
    return {
      biomeId,
      version: VERSION,
      decorations: [],
      platforms: [],
      blocks: [],
    };
  },
};
